<div class="row">
    <div class="col-md-12 text-center">
        <h4 class="mb-5 form-text-heading2">
            <i class="fas fa-user-tie form-icon-heading" aria-hidden="true"></i> Fotoğraf Düzenle
        </h4>
    </div>
</div>
<div class="row">
    <div class="col-md-8">
        <image-cropper 
            [imageChangedEvent]="fileEvent" 
            [maintainAspectRatio]="false" 
            [aspectRatio]="1/1"
            [resizeToWidth]="256" 
            [resizeToHeight]="256" 
            format="png" 
            (imageCropped)="imageCropped($event)" 
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()" 
            (loadImageFailed)="loadImageFailed()">
        </image-cropper>
    </div>
    <div class="col-md-4">
        <h5>Önizleme</h5>
        <div class="my-auto">
            <img class="img-fluid" [src]="croppedImage">
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-12 text-center">
        <div class=" tablo-button">
            <button type="button" class="btn tablo-edit-button" (click)="cancel()">İptal</button>
            <button type="button" class="btn tablo-new tablo-new-button" (click)="update()"
                [disabled]="isUpdating">
                <i class="fa fa-spin fa-spinner" *ngIf="isUpdating"></i>
                Kaydet
            </button>
        </div>
    </div>
</div>